import Unity, { UnityContext } from 'react-unity-webgl';
import { AiFillInstagram } from 'react-icons/ai';
import { FaTwitter } from 'react-icons/fa';
import { MdFullscreen } from 'react-icons/md';

import { Background, GameControls, FullScreenButton, Socials } from './styles';

const unityContext = new UnityContext({
  loaderUrl: '/game/anubisbuild.loader.js',
  dataUrl: '/game/anubisbuild.data',
  frameworkUrl: '/game/anubisbuild.framework.js',
  codeUrl: '/game/anubisbuild.wasm',
});

export const Game = () => {
  function handleOnClickFullscreen() {
    unityContext.setFullscreen(true);
  }

  return (
    <Background>
      <Unity
        unityContext={unityContext}
        style={{ width: '1280px', height: '720px' }}
      />
      <GameControls>
        <Socials>
          <a href="https://twitter.com/anubisrushgame">
            <FaTwitter size={36} color="#fff" />
          </a>
          <a href="https://www.instagram.com/anubisrushgame/">
            <AiFillInstagram size={36} color="#fff" />
          </a>
        </Socials>
        <FullScreenButton type="button" onClick={handleOnClickFullscreen}>
          <MdFullscreen size={40} color="#fff" />
        </FullScreenButton>
      </GameControls>
    </Background>
  );
};
